<template>
  <div class="frontend_html" :style="{'min-height': layout.height + 'px'}">
    <Tabs value="name1">
      <TabPane label="非对称加密" name="name1">
        <Row>
          <Col span="11">
            <Label>公钥(Public Key)：</Label>
            <Input v-model="item1.public_key" style="margin-top:20px;" type="textarea"
                   :autosize="{minRows: 5,maxRows: 8}"
                   placeholder="请输入公钥 Public Key ..."/>
          </Col>
          <Col span="11" offset="1">
            <Label>私钥(Private Key)：</Label>
            <Input v-model="item1.private_key" style="margin-top:20px;" type="textarea"
                   :autosize="{minRows: 5,maxRows: 8}"
                   placeholder="请输入私钥 Private Key ..."/>
          </Col>
        </Row>
        <Row style="margin-top:50px;">
          <Label>待加密字符串：</Label>
          <Input v-model="item1.source_data" style="margin-top:20px;" type="textarea"
                 :autosize="{minRows: 8,maxRows: 12}"
                 placeholder="请输入待加密字符串 ..."/>
        </Row>
        <Row style="margin-top:20px;">
          <Col span="3">
            <Select v-model="item1.type">
              <Option value="RSA_PKCS1">RSA(PKCS1)</Option>
              <Option value="ECDSA" :disabled="true" >ECDSA</Option>
              <Option value="DSA" :disabled="true" >DSA</Option>
            </Select>
          </Col>
          <Col span="3" offset="1">
            <Button type="warning" @click="item1_encode()">加密↓</Button>
            <Button type="info" @click="item1_decode()">解密↑</Button>
          </Col>
        </Row>
        <Row style="margin-top:20px;">
          <Label>待解密字符串：</Label>
          <Input v-model="item1.encode_data" style="margin-top:20px;" type="textarea"
                 :autosize="{minRows: 8,maxRows: 12}"
                 placeholder="请输入待加密字符串 ..."/>
        </Row>
      </TabPane>
      <TabPane label="对称加密" name="name2" v-if="false">
        des
      </TabPane>
      <TabPane label="哈希摘要" name="name3" v-if="false">
        hash
      </TabPane>
    </Tabs>

  </div>
</template>

<script>
  let crypto = require('crypto');

  export default {
    name: "html_format",
    data(){
      return {
        item1: {
          type: "RSA_PKCS1",
          public_key: "",
          private_key: "",
          source_data: "",
          encode_data: "",
        },
        layout: {
          height: 0,
        }
      }
    },
    computed: {},
    mounted(){
      let that = this;
      this.$nextTick(()=>{
        that.resizeWindow();
        $(window).resize(function(){
          that.resizeWindow();
        });
      })
    },
    methods: {
      resizeWindow(){
        this.layout.height = window.innerHeight - window.layout.header_height - window.layout.footer_height;
      },
      item1_encode(){
        if(this.item1.type === "RSA_PKCS1"){
          try{
            let buffer = new Buffer(this.item1.source_data);
            let encrypted = crypto.publicEncrypt(this.item1.public_key, buffer);
            let encryptedStr = encrypted.toString('base64');
            this.item1.encode_data = encryptedStr;
          }catch(e){
            this.item1.encode_data = "加密失败，公钥格式不正确：" + e.toString()
          }
        }
      },
      item1_decode(){
        if(this.item1.type === "RSA_PKCS1"){
          try{
            let buffer = new Buffer(this.item1.encode_data, 'base64');
            let decrypted = crypto.privateDecrypt({
              key: this.item1.private_key,
              padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,

            }, buffer);
            let decryptedStr = decrypted.toString('utf8');
            this.item1.source_data = decryptedStr;
          }catch(e){
            this.item1.source_data = "解密失败，加密原文不正确或密钥不正确：" + e.toString()
          }
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../../src/theme/default.less";

  .frontend_html {
    label {
      font-size: 15px;
      font-weight: 500;
    }
    display: flex;
    flex-direction: column;
    padding: 20px 20px 20px 20px;
    .data-area {
      display: flex;
      flex-direction: row;
      height: 100%;
      .left_editor {
        display: flex;
        flex: 1;
        margin-right: 10px;
        height: 100%;
      }
      .right_editor {
        overflow: auto;
        display: flex;
        flex: 1;
        margin-right: 10px;
        height: 100%;
      }
    }
    .opera-area {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      height: 50px;
      * {
        margin: 0 10px;
      }
    }
  }

  textarea {
    resize: none;
  }
</style>
